
import {
getMobileCode, checkOrderNumber
} from "@/api/bindMobileNumber"
import Alert from 'vux/src/components/alert/index.vue'

export default {
data() {
return {
orderNum:"",//订单号
phoneNum:"",//手机号
codeNum:"",//验证码
sendDisabled:true,
enderDisabled:true,
countdown:60,//倒计时
btnMessage:"获取验证码"
};
},

components: {},

computed: {},

created() {},

mounted() {},

methods: {

phoneInputFun:function(event){
this.phoneNum = event.currentTarget.value;
if(this.phoneNum.length >= 11){
this.sendDisabled = false;
}
},

sendFun:function(){

if(this.orderNum.length <= 0){
this.$vux.toast.text("请输入订单号", 'middle');
return;
}

let params = {
orderId:this.orderNum,
mobile:this.phoneNum
}
let that = this;
checkOrderNumber(params).then(res => {
if (res.code == 1) {
that.countdown = 60;
that.setTime(that.countdown)
}else{
that.$vux.toast.text(res.desc, 'middle');
}
})

},
setTime:function(val) {
let that = this;
if(that.countdown == 0) {
that.sendDisabled = false;
that.btnMessage = "获取验证码";
that.countdown = 61;
} else {
that.sendDisabled = true;
that.btnMessage = "重新发送(" + that.countdown + ")";
that.countdown--;
}
if(that.countdown != 61){
setTimeout(function() {
that.setTime(val)
}, 1000)
}

},

codeInputFun:function(event){
this.codeNum = event.currentTarget.value;
if(this.codeNum.length == 6){
this.enderDisabled = false;
}
},

bindFun:function(){
let that = this;
let params = {
orderId:this.orderNum,
mobile:this.phoneNum,
code:this.codeNum
}
checkOrderNumber(params).then(res => {
if (res.code == 1) {
this.$vux.toast.text("绑定成功", 'middle');
setTimeout(function() {
window.history.go(-1);
}, 2000)
}else{
this.$vux.toast.text(res.desc, 'middle');
}
})
}

}
};



// WEBPACK FOOTER //
// ./src/view/bindMobileNumber/bindMobileNumber.vue